<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M81.9401 31.76C81.1601 29.83 79.4701 28.55 77.5701 28.19C77.1101 28.07 76.6201 28 76.1201 28H63.5801C59.5801 28 56.3401 31.24 56.3401 35.24C56.3401 39.24 59.5801 42.48 63.5801 42.48H70.6501L77.0501 58.32C78.2701 61.33 81.6901 62.78 84.7001 61.57L92.6801 58.34L81.9301 31.76H81.9401Z"
      fill="#CB80DE"
    />
    <path
      d="M104.56 51.77L80.86 46.41C75.58 45.21 70.55 49.23 70.55 54.65V57.03C70.55 57.03 70.53 57.07 70.51 57.07L16.25 61.07C11.85 61.39 8.18 64.86 8.01 69.27C7.85 73.47 10.74 77.02 14.63 77.91C10.72 79.74 8 83.7 8 88.3C8 94.64 13.14 99.77 19.47 99.77H53.65C59.99 99.77 65.12 94.63 65.12 88.3C65.12 83.88 62.61 80.04 58.94 78.13H81.2L86.52 92.98C87.11 94.61 89.16 95.23 91.12 94.36L97.68 91.43C99.63 90.56 100.74 88.53 100.16 86.89L97.02 78.12H107.21C111.87 78.12 115.66 74.34 115.66 69.67V65.66C115.66 59 111.05 53.23 104.55 51.76L104.56 51.77Z"
    />
    <path
      d="M102.4 99.76H75.5799C71.8999 99.76 68.9199 96.78 68.9199 93.1C68.9199 89.42 71.8999 86.44 75.5799 86.44H102.4C102.81 86.44 103.23 86.34 103.59 86.15L111 82.3C114.26 80.6 118.29 81.87 119.98 85.14C121.68 88.4 120.41 92.43 117.14 94.12L109.73 97.97C107.47 99.14 104.94 99.76 102.39 99.76H102.4Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'SnowMobileInsurance'
  }
</script>
